import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const StyledButton1 = withStyles({
    root: {
      color:"#F07338",
      borderRadius: 3,
      border: '1 solid',
      borderColor:"#F07338",
      height: 40,
      padding: '0 30px',
      fontSize:'14px'
    },
    label: {
      textTransform: 'capitalize',
    },
})(Button);


export default StyledButton1
